import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { FpCorrelationGraphStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.store';
import { FpCorrelationGraphInfoComponent } from '../fp-correlation-graph-info/fp-correlation-graph-info.component';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { FloatingPopupLineChartWrapperComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-line-chart-wrapper/floating-popup-line-chart-wrapper.component';
import { FpCorrelationGraphChartService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph-chart.service';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-correlation-graph-minimized',
  standalone: true,
  imports: [
    ElementWidthClassDirective,
    FpCorrelationGraphInfoComponent,
    FloatingPopupLineChartWrapperComponent,
    FloatingPopupBaseErrorMessageComponent,
  ],
  templateUrl: './fp-correlation-graph-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpCorrelationGraphMinimizedComponent {
  public readonly currentTabStore = inject(FpCorrelationGraphStore);
  protected readonly translateService = inject(TranslateService);
  protected readonly chartService = inject(FpCorrelationGraphChartService);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  private readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isChartDataExist = computed(() => !!this.data()?.length);

  public readonly correlation = computed(() => this.popupMainData()?.correlation);

  public combinedChartData = computed(() => {
    const data = this.data() || [];
    const measurementSystem = this.currentTabStore.viewMeasurementSystem();

    const chartData = this.chartService.getMinimizedDataForChart(data, measurementSystem);
    const chartOptions = this.chartService.generateMinimizedOptions(data, measurementSystem);

    return { chartData, chartOptions };
  });
}
